import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import ScreenPagePart from "../../components/login/screenpage";
import RecoverPasswordForm from "../../components/login/recover";

const RecoverPage = () => {
  return (
    <ScreenPagePart>
      <div className="inner centerItem">
        <RecoverPasswordForm />
      </div>
    </ScreenPagePart>
  );
};

export default RecoverPage;